import { useI18n } from "../i18n/I18nContext";

export default function LanguageToggle({ variant = "light", className = "" }) {
  const { lang, setLang } = useI18n();
  const baseBtn = "px-3 py-1.5 text-xs font-semibold tracking-[0.18em] uppercase transition-all duration-300 rounded-full";

  const isDark = variant === "dark";
  const containerCls = isDark
    ? "inline-flex items-center rounded-full border border-white/20 bg-white/5 backdrop-blur-md p-1"
    : "inline-flex items-center rounded-full border border-charcoal/15 bg-white p-1 shadow-sm";

  const activeCls = isDark ? "bg-gold-500 text-charcoal" : "bg-charcoal text-white";
  const inactiveCls = isDark
    ? "text-white/70 hover:text-white"
    : "text-charcoal/60 hover:text-charcoal";

  return (
    <div className={`${containerCls} ${className}`} role="group" aria-label="Language">
      <button type="button" data-testid="language-toggle-vi" onClick={() => setLang("vi")}
        className={`${baseBtn} ${lang === "vi" ? activeCls : inactiveCls}`}>
        Tiếng Việt
      </button>
      <button type="button" data-testid="language-toggle-en" onClick={() => setLang("en")}
        className={`${baseBtn} ${lang === "en" ? activeCls : inactiveCls}`}>
        English
      </button>
    </div>
  );
}
